var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3797 3.54967C8.6726 3.25678 9.14747 3.25678 9.44036 3.54967L15.9604 10.0697C17.0233 11.1326 17.0233 12.8674 15.9604 13.9303L9.44036 20.4503C9.14747 20.7432 8.6726 20.7432 8.3797 20.4503C8.08681 20.1574 8.08681 19.6826 8.3797 19.3897L14.8997 12.8697C15.3768 12.3926 15.3768 11.6074 14.8997 11.1303L8.3797 4.61033C8.08681 4.31744 8.08681 3.84256 8.3797 3.54967Z",
    fill: "#03182F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.ab8fdb264aee969fd1ecf841bafc8223.svg";
export { ForwardRef as ReactComponent };